<template>
    <div id="availableOverdueAsset">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Available Overdue Asset List</div>
                    <a href="javascript:void(0)" class="btn btn-secondary pull-right" v-on:click="exportReports()">
                        <i class="fp-export"></i> Export
                    </a>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content available-overdue-asset-list">
                        <data-table-filter-config :moduleName="'availableOverdueAsset'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="data-table bg-white">
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange" :moduleName="'availableOverdueAsset'" :position="'top'">
                                  </custom-pagination>

                                  <vue-good-table
                                      ref="availableOverdueAsset"
                                      mode="remote"
                                      title="News"
                                      @on-page-change="onPageChange"
                                      @on-selected-rows-change="selectionChanged"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-sort-change="onSortChange"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          perPageDropdown:dropDownPerPage,
                                          dropdownAllowAll: false,
                                      }"
                                      :select-options="{
                                      enabled: false,
                                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                      selectionInfoClass: 'custom-class',
                                      selectionText: 'rows selected',
                                      clearSelectionText: 'clear',
                                      }"
                                      :search-options="{
                                      enabled: false,
                                      }">
                                  </vue-good-table>
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

    import EventBus from "./../event-bus";
    import Vue from "vue";


    
    



    import {commonMixins} from '../../mixins/commonMixins';
    import {dataTableMixins} from '../../mixins/dataTableMixins';

    export default {
        name: "availableOverdueAssetList",
        mixins:[commonMixins,dataTableMixins],
        props: {
            assetAvailabilityVal: {
                type: Array,
                required: true,
                default:undefined
            }
        },
        data: () => ({
            availabilityFromDate:null,
            availabilityToDate:null,
            availabilityLocation:"",
            availabilityAssetType:"",
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Unit Number',
                    field: 'unit_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Own',
                    field: 'owner',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Curr Pool',
                    field: 'pool',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Name',
                    field: 'name',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:true,
                },
                {
                    label: 'Vin',
                    field: 'vin',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:true,
                },
                {
                    label: 'Alloc',
                    field: 'allocation',
                    fpFieldType:"option",
                    filterable: false,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterDropdownItems: ['Yes', 'No'],
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable: false,
                },
                {
                    label: 'Rsvd',
                    field: 'reserved',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterDropdownItems: ['Yes', 'No'],
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable: false,
                },
                {
                    label: 'Avbl',
                    field: 'available',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterDropdownItems: ['Yes', 'No'],
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable: false,
                },
                {
                    label: 'Overdue',
                    field: 'overdue',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterDropdownItems: ['Yes', 'No'],
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable: false,
                },
                {
                    label: 'Equipment Type',
                    field: 'asset_type',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Unit Year',
                    field: 'year',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Make',
                    field: 'make',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Model',
                    field: 'model',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Assign Facility',
                    field: 'location',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Physical Loc Fac',
                    field: 'phys_location',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Region',
                    field: 'region',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                    sortable: false,
                },
                {
                    label: 'Current Customer',
                    field: 'customer',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    sortable: true,
                },
                {
                    label: 'Customer Name',
                    field: 'customer_name',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    sortable: true,
                },
                {
                    label: 'Reservation Number',
                    field: 'reservation_number',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Reserved From Date',
                    field: 'pickup_date',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Resvd From Time',
                    field: 'pickup_time',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'Reserved To Date',
                    field: 'dropoff_date',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Resvd To Time',
                    field: 'dropoff_time',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'Alloc Source',
                    field: 'alloc_source',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                    sortable: false,
                },
                {
                    label: 'Allocated Number',
                    field: 'alloc_no',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                    sortable: false,
                },
                {
                    label: 'Planned In Date',
                    field: 'planned_in_date',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Planned In Time',
                    field: 'planned_in_time',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'Status',
                    field: 'status',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:true,
                },

                // {
                //     label: 'Odometer Reading',
                //     field: 'odometer_reading',
                //     filterable: true,
                //     filterOptions: {
                //         enabled: true, // enable filter for this column
                //         placeholder: "Reading", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                // {
                //     label: 'Reading Updated At',
                //     field: 'odometer_reading_time',
                //     filterable: true,
                //     filterOptions: {
                //         enabled: true, // enable filter for this column
                //         placeholder: "MM/DD/YYYY", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                {
                    label: 'Purchase Date',
                    field: 'purchase_date',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:true,
                },
                {
                    label: 'Date In Service',
                    field: 'date_in_service',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:true,
                },
                {
                    label: 'Available On',
                    field: 'available_on',
                    fpFieldType:"custom_asset_availability",
                    hidden: true,
                    sortable: false,
                },
            ],
            rows: [],
            totalRecords: 0,
            asset_value: false,
            loading:false,
            accessAddAsset:false,
            accessCheckAvailability:false,
            loadAsset:'false',
            searchAsset:true,
            canMakeReservation:false,
            canViewAsset:false,
            getDataOf: '',
            pickupDate:"",
            dropoffDdate:"",
            action:'list',
            batchProcess:0,
            batchNum:"",
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'available_overdue_asset_report') {
                            self.cantAccessPage = true;
                        }
                    }
                }
            },
        },
        created: function() {
            this.serverParams.sort = {field:"dropoff_date",type:"desc"};
        },

        mounted: function() {
            var self = this;

            self.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.availableOverdueAsset.unselectAllInternal();
            },
            // exportReports: function() {
            //     var self = this;
            //     this.action = "export";
            //     this.loadList();
            // },

            loadList: function() {

                var self = this;
                self.loading = true;

                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    action:self.action
                };

                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/get-available-and-overdue-asset",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            if ( self.action == "export" ||  self.action == "export_queue") {
                              if ( data.code == "201" ) {
                                  alert(data.message);
                              } else {
                                  if ( self.action == "export" ) {
                                      self.excel = data.content.web;
                                      var save = document.createElement("a");
                                      save.href = self.excel;
                                      save.download = data.content.web;
                                      save.target = "_blank";

                                      document.body.appendChild(save);
                                      save.click();
                                      document.body.removeChild(save);

                                  } else {

                                      self.batchProcess = 1;
                                      self.batchNum = data.content;
                                  }
                              }
                              self.action = "list";
                              // self.loadList();
                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                            }


                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'available-overdue-rsvtn-list')
                    }
                });
            },

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/reports/AvailableOverdueAsset.vue